export const queryKeys = {
  base: ['phone'] as const,
  deviceById: () => [...queryKeys.base, 'deviceById'],
  devicesList: () => [...queryKeys.base, 'devices', 'list'],
  deviceAddressById: () => [...queryKeys.base, 'device', 'e911-address'],
  validateDestroyLine: (id: string) => [...queryKeys.base, 'validate-destroy-line', id],
};
